/* ============================================================
   DOGS SUPREME · <ds-steuer-rechner>
   Hundesteuer: Satzungswerte nachschlagen und zusammenrechnen.

   DATENQUELLE: window.DS_STEUER_DATEN (assets/ds-steuer-daten.js),
   generiert aus bi_tools/data/hundesteuer_kommunen.json.
   Das JSON ist Single Source of Truth fuer Widget, Artikel-Tabelle und FAQ.
   NIE eine Zahl hier hartkodieren.

   RECHTS-LEITPLANKEN (bindend, Plan 17.07.2026, StBerG/RDG):
     · Keine Befreiungs-/Ermaessigungspruefung. Satzungsstelle zitieren, nicht subsumieren.
     · Keine Handlungsempfehlung ("melde deinen Hund um" ist explizit verboten).
     · Keine Bescheidpruefung, keine Freitextfelder.
     · KEINE Schaetzung bei fehlender Gemeinde. Lieber keine Zahl als eine erfundene.
     · Output ist ein Satzungswert ("Die Satzung von X nennt ..."), nicht "Du zahlst ...".
     · Nie "Dein Hund ist ein Listenhund". Ob die Rasse zutrifft, entscheidet die Behoerde.

   DSGVO: kein fetch mit Nutzereingabe, kein Cookie, kein Analytics-Event mit der
   Ortswahl. Die Daten kommen als eine statische Datei, gematcht wird lokal.

   UI-Schicht: assets/ds-nav-foundation.css (.dsn-*), Spec
   docs/standards/navigator-design-spec.md. Das Element scopet sich selbst
   (.dsn-scope), damit die Foundation nicht angefasst werden muss.
   Kompatibilitaet wie ds-tm-rechner.js: ES2015-Klasse, keine #-Felder,
   kein Optional-Chaining, var + function.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Pure Logik (Node-testbar) ---------- */

  var STALE_WARN_MONATE = 12;
  var STALE_HIDE_MONATE = 24;

  function monateSeit(iso, heuteIso) {
    var a = new Date(iso + 'T00:00:00Z');
    var b = new Date(heuteIso + 'T00:00:00Z');
    if (isNaN(a.getTime()) || isNaN(b.getTime())) return null;
    return (b.getUTCFullYear() - a.getUTCFullYear()) * 12 + (b.getUTCMonth() - a.getUTCMonth());
  }

  /* Verfalls-Gate: bricht die Pflege ab, verschwinden die Zahlen,
     statt still falsch zu werden. */
  function staleLevel(geprueftAm, heuteIso) {
    var m = monateSeit(geprueftAm, heuteIso);
    if (m === null) return 'unterdruecken';
    if (m >= STALE_HIDE_MONATE) return 'unterdruecken';
    if (m >= STALE_WARN_MONATE) return 'warnen';
    return 'ok';
  }

  function isStale(geprueftAm, heuteIso) {
    return staleLevel(geprueftAm, heuteIso) !== 'ok';
  }

  /* Faltet beide Umlaut-Wege: ä->ae UND ä->a. Sonst findet "munchen" nichts. */
  function normalizeSearch(s) {
    if (typeof s !== 'string') return '';
    var t = s.toLowerCase().trim();
    t = t.replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss');
    t = t.replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u');
    return t.replace(/[^a-z0-9]/g, '');
  }

  function matchOrt(kommunen, q) {
    var n = normalizeSearch(q);
    if (n.length < 2) return [];
    var out = [];
    for (var i = 0; i < kommunen.length; i++) {
      var k = kommunen[i];
      var kandidaten = [k.name].concat(k.alias || []);
      var treffer = false;
      for (var j = 0; j < kandidaten.length; j++) {
        if (normalizeSearch(kandidaten[j]).indexOf(n) === 0) { treffer = true; break; }
      }
      if (treffer) out.push(k);
    }
    return out;
  }

  /* Abdeckung wird GERECHNET, nie behauptet. "100 von 10.749 Gemeinden" waere wahr,
     aber sinnlos gerahmt; "die Wohnorte von X Millionen Menschen" ist dieselbe
     Wahrheit, richtig gerahmt, und aus den Daten belegbar. */
  function coverage(kommunen) {
    var ew = 0;
    for (var i = 0; i < kommunen.length; i++) ew += (kommunen[i].ew || 0);
    return { staedte: kommunen.length, einwohner: ew };
  }

  /* Kern: die drei unvereinbaren Staffel-Systeme der Satzungen.
       flat       Koeln  "fuer jeden gehaltenen Hund 174,00 EUR"  -> 2 Hunde = 2 x 174
       kumulativ  Berlin "erster 120, jeder weitere 180"          -> 2 Hunde = 120 + 180
       pro_kopf   Duesseldorf "zwei Hunde, JE HUND 150,00 EUR"    -> 2 Hunde = 2 x 150
     Ein Modell, das das nicht unterscheidet, rechnet Duesseldorf um 54 EUR falsch. */
  function staffelSumme(saetze, typ, anzahl) {
    if (!saetze || !saetze.length || !(anzahl > 0)) return { summe: null, teil: null, fehlt: true };
    if (typ === 'flat') {
      return { summe: saetze[0] * anzahl, teil: saetze[0] * anzahl, fehlt: false };
    }
    if (typ === 'kumulativ') {
      if (anzahl === 1) return { summe: saetze[0], teil: saetze[0], fehlt: false };
      /* Nur der erste Satz bekannt: nicht hochrechnen, das waere geraten. */
      if (saetze.length < 2) return { summe: null, teil: saetze[0], fehlt: true };
      /* Jeder Hund zu SEINER Stufe, der letzte Satz gilt fuer alle weiteren.
         Die Vorgaenger-Formel (saetze[0] + saetze[1] * (anzahl-1)) konnte nur zwei
         Stufen. Rostock hat drei ("a) ersten 108, b) zweiten 144, c) dritten und
         jeden weiteren 168") und kam damit bei drei Hunden auf 396 statt 420.
         Alle bis dahin erfassten Staedte waren zweistufig, deshalb fiel es nicht auf. */
      var summe = 0;
      for (var i = 0; i < anzahl; i++) summe += saetze[Math.min(i, saetze.length - 1)];
      return { summe: summe, teil: summe, fehlt: false };
    }
    if (typ === 'pro_kopf') {
      var stufe = Math.min(anzahl, saetze.length) - 1;
      if (saetze[stufe] === undefined || saetze[stufe] === null) {
        return { summe: null, teil: saetze[0], fehlt: true };
      }
      return { summe: saetze[stufe] * anzahl, teil: saetze[stufe] * anzahl, fehlt: false };
    }
    return { summe: null, teil: null, fehlt: true };
  }

  /* Liefert IMMER ein Objekt, nie null. Teilergebnis statt Totalausfall:
     97 % der Datensaetze sind am Anfang unvollstaendig, ein null waere unbrauchbar. */
  function computeSteuer(kom, opts) {
    opts = opts || {};
    var anzahl = opts.anzahl || 1;
    var listen = !!opts.listen;
    var kat1 = !!opts.kat1;
    var hinweise = [];
    var zeilen = [];

    if (!kom) return { summe: null, teilsumme: null, verboten: false, hinweise: [], zeilen: [] };

    /* Kat-1: verboten, nicht teurer. Der Rechner darf hier KEINE Zahl zeigen. */
    if (kat1 && kom.kat1_verboten) {
      return {
        summe: null, teilsumme: null, verboten: true, zeilen: [],
        hinweise: [kom.kat1_hinweis || ('In ' + kom.name + ' ist die Haltung dieser Hunde nicht erlaubt. Dafuer gibt es keinen Steuersatz.')]
      };
    }

    if (listen) {
      /* null + geprueft = "existiert nicht", NICHT "unbekannt". Ohne diese
         Unterscheidung entsteht wieder eine erfundene Zahl wie Koelns 672. */
      if (kom.listen_satz === null && kom.listen_geprueft) {
        hinweise.push(kom.listen_hinweis || ('Die Satzung von ' + kom.name + ' nennt keinen erhöhten Satz für gefährliche Hunde.'));
      } else if (kom.listen_satz === null || kom.listen_satz === undefined) {
        return {
          summe: null, teilsumme: null, verboten: false, zeilen: [],
          hinweise: ['Für ' + kom.name + ' liegt uns kein geprüfter Satz für gelistete Hunde vor. Bitte in der verlinkten Satzung nachsehen.']
        };
      } else {
        /* Der Listen-Satz ist IMMER je Hund, auch wo die Grundsaetze kumulativ
           staffeln: Rostock sagt "fuer jeden gefaehrlichen Hund 1.000 EUR",
           Braunschweig "fuer jeden gefaehrlichen Hund ... 804,00 €". Zwei Hunde
           kosten dort 2.000 bzw. 1.608, nicht erster-plus-weiterer.
           Vier Staedte staffeln zusaetzlich den Listen-Satz selbst (Duesseldorf
           600/900/1200, Bonn 840/1140, Krefeld 800/900, Luenen 468/612/684):
           dann gilt die Stufe nach Anzahl, und wieder je Hund. */
        var lStaffel = kom.listen_staffel || [kom.listen_satz];
        var lSatz = lStaffel[Math.min(anzahl, lStaffel.length) - 1];
        var lSumme = lSatz * anzahl;
        zeilen.push({ label: anzahl > 1 ? ('Gelistete Hunde (' + anzahl + ')') : 'Gelisteter Hund', wert: lSumme });
        return { summe: lSumme, teilsumme: lSumme, verboten: false, zeilen: zeilen, hinweise: hinweise };
      }
    }

    var r = staffelSumme(kom.saetze, kom.staffel_typ, anzahl);
    if (r.fehlt) {
      hinweise.push('Für ' + kom.name + ' ist in unserer Erfassung nur der Satz für den ersten Hund belegt. Den Satz für weitere Hunde findest du in der verlinkten Satzung.');
      if (r.teil !== null) zeilen.push({ label: 'Erster Hund', wert: r.teil });
      return { summe: null, teilsumme: r.teil, verboten: false, zeilen: zeilen, hinweise: hinweise };
    }

    if (kom.staffel_typ === 'kumulativ' && anzahl > 1) {
      zeilen.push({ label: 'Erster Hund', wert: kom.saetze[0] });
      zeilen.push({ label: (anzahl - 1) + ' weitere' + (anzahl === 2 ? 'r Hund' : ' Hunde'), wert: kom.saetze[1] * (anzahl - 1) });
    } else if (kom.staffel_typ === 'pro_kopf' && anzahl > 1) {
      var st = Math.min(anzahl, kom.saetze.length) - 1;
      zeilen.push({ label: anzahl + ' Hunde, je ' + kom.saetze[st] + ' Euro', wert: r.summe });
    } else {
      zeilen.push({ label: anzahl > 1 ? (anzahl + ' Hunde') : 'Ein Hund', wert: r.summe });
    }

    return { summe: r.summe, teilsumme: r.teil, verboten: false, zeilen: zeilen, hinweise: hinweise };
  }

  /* Node-Testhook: im Browser inert. */
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      computeSteuer: computeSteuer,
      staffelSumme: staffelSumme,
      isStale: isStale,
      staleLevel: staleLevel,
      normalizeSearch: normalizeSearch,
      matchOrt: matchOrt,
      coverage: coverage
    };
    return;
  }

  if (!('customElements' in window) || customElements.get('ds-steuer-rechner')) return;

  /* ---------- Browser-Schicht ---------- */

  function ensureFoundation() {
    if (document.getElementById('dsn-foundation')) return;
    var probe = document.querySelector('link[href*="ds-nav-foundation"]');
    if (probe) { probe.id = probe.id || 'dsn-foundation'; return; }
    var self = document.querySelector('script[src*="ds-steuer-rechner"]');
    if (!self) return;
    var link = document.createElement('link');
    link.id = 'dsn-foundation';
    link.rel = 'stylesheet';
    link.href = self.src.split('?')[0].replace(/ds-steuer-rechner\.js$/, 'ds-nav-foundation.css');
    document.head.appendChild(link);
  }

  function injectStyles() {
    if (document.getElementById('ds-steuer-rechner-styles')) return;
    var style = document.createElement('style');
    style.id = 'ds-steuer-rechner-styles';
    style.textContent = [
      /* Das Element scopet sich selbst: die Foundation nennt die Widget-Namen an
         5 Selektor-Stellen und wird von 7 Live-Seiten geladen. Nicht anfassen. */
      "ds-steuer-rechner{display:block;margin:28px 0;font-family:var(--dsn-font);-webkit-font-smoothing:antialiased;color:var(--dsn-ink);hyphens:none}",
      "ds-steuer-rechner *{box-sizing:border-box}",
      /* type=search-Absicherung: Safari legt sonst sein eigenes Suchfeld-Chrome
         (Rundung, Icon-Insets) ueber das Foundation-Design. -webkit-appearance:none
         nur auf dem Feld selbst, das eingebaute graue Loesch-Icon (::-webkit-search-
         cancel-button) bleibt unangetastet und damit nativ. Nur hier ueberschrieben,
         die Foundation-Datei selbst bleibt unangetastet (laedt 7 andere Flaechen). */
      "ds-steuer-rechner .dsn-input{-webkit-appearance:none;appearance:none}",
      "ds-steuer-rechner .dsst-amount{font-size:34px;line-height:1.21;font-weight:700;letter-spacing:-.02em;color:var(--dsn-ink);margin:0;font-variant-numeric:tabular-nums}",
      "ds-steuer-rechner .dsst-amount-sub{font-size:15px;color:var(--dsn-ink-2);margin:4px 0 0}",
      "ds-steuer-rechner .dsst-src{font-size:13px;line-height:1.38;color:var(--dsn-ink-2);margin:12px 0 0}",
      "ds-steuer-rechner .dsst-quote{font-size:13px;line-height:1.45;color:var(--dsn-ink-2);margin:8px 0 0;padding-left:10px;border-left:2px solid var(--dsn-border)}",
      "ds-steuer-rechner .dsst-hits{margin-top:8px}",
      "ds-steuer-rechner .dsst-ort{display:flex;flex-direction:column;align-items:flex-start;gap:1px;min-width:0}",
      "ds-steuer-rechner .dsst-ort-name{font-size:17px;color:var(--dsn-ink)}",
      "ds-steuer-rechner .dsst-ort-meta{font-size:12px;color:var(--dsn-ink-2)}",
      /* Tick-Kreis nach Spec 3.3: leer = Ring, gewaehlt = Akzent + weisser Haken */
      "ds-steuer-rechner .dsn-tick{flex:0 0 24px;height:24px;border-radius:999px;border:1.5px solid var(--dsn-border);",
      "  display:inline-block;position:relative}",
      "ds-steuer-rechner .dsn-tick--on{background:var(--dsn-accent);border-color:var(--dsn-accent)}",
      "ds-steuer-rechner .dsn-tick--on::after{content:'';position:absolute;left:8px;top:4px;width:5px;height:10px;",
      "  border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg)}",
      "ds-steuer-rechner .dsst-rassen{max-height:340px;overflow-y:auto;-webkit-overflow-scrolling:touch}",
      "ds-steuer-rechner .dsst-annahmen{margin-top:14px;padding-top:12px;border-top:1px solid var(--dsn-sep)}",
      /* Zweite Redesign-Runde 19.07.2026: Betrag und Beleg-Kram sind jetzt zwei
         getrennte Karten (Hero + Detailbox) statt einer gemeinsamen grauen Box.
         Die alte Doppelstrich-Reparatur (.dsn-kv:has(+.dsst-annahmen)) entfaellt
         damit von selbst: .dsn-kv (Betragszeilen) und .dsst-annahmen sind keine
         Geschwister mehr, liegen in unterschiedlichen Karten. Stattdessen: Luecke
         zwischen den Karten, und .dsst-annahmen verliert Rand/Abstand, wenn sie
         als erstes Kind direkt am Kartenrand der Detailbox steht (sonst haenge
         eine Linie im Leeren). */
      "ds-steuer-rechner .dsst-detailbox{margin-top:16px}",
      "ds-steuer-rechner .dsst-detailbox > .dsst-annahmen:first-child{margin-top:0;padding-top:0;border-top:none}",
      "ds-steuer-rechner .dsst-annahme{font-size:15px;line-height:1.5;color:var(--dsn-ink-2);margin:12px 0 0}",
      "ds-steuer-rechner .dsst-toggle{background:none;border:0;padding:0;font-size:15px;cursor:pointer;min-height:auto}",
      /* Kopfzeile der aufgeklappten Rassenliste: Label links, Schliessen rechts. */
      "ds-steuer-rechner .dsst-rassen-kopf{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:8px}",
      "ds-steuer-rechner .dsst-schliessen{background:none;border:0;padding:6px 2px;font-size:14px;line-height:1;",
      "color:var(--dsn-accent);cursor:pointer;min-height:auto;white-space:nowrap;flex:none}",
      "ds-steuer-rechner .dsst-schliessen:hover{opacity:.7}",
      "ds-steuer-rechner .dsst-actions{display:flex;gap:16px;flex-wrap:wrap;margin-top:18px;align-items:center}",
      /* PDF ist ein Add-on: dezenter Textknopf, kein CTA. Die eine Akzent-Aktion
         pro View gehoert der Anmeldeseite. */
      "ds-steuer-rechner .dsst-pdf{background:none;border:0;padding:0;font-size:13px;line-height:1.38;",
      "  color:var(--dsn-ink-2);cursor:pointer;text-decoration:underline;text-underline-offset:2px;min-height:auto}",
      "ds-steuer-rechner .dsst-pdf:hover{color:var(--dsn-ink)}",
      "ds-steuer-rechner .dsst-pflicht{display:flex;gap:8px;font-size:14px;line-height:1.5;color:var(--dsn-ink-2);padding:4px 0}",
      /* Ausklapper (Zitat, Pflichten, Quelle): natives details/summary, siehe
         details()-Helper. Rand kommt vom details selbst, nicht mehr vom Inhalt,
         Mobile-Redesign 19.07.2026. */
      "ds-steuer-rechner .dsst-details{border-top:1px solid var(--dsn-sep)}",
      "ds-steuer-rechner .dsst-annahmen + .dsst-details{margin-top:0}",
      "ds-steuer-rechner .dsst-summary{display:flex;align-items:center;justify-content:space-between;",
      "  padding:13px 0;font-size:15px;color:var(--dsn-ink);cursor:pointer;list-style:none;min-height:44px}",
      "ds-steuer-rechner .dsst-summary::-webkit-details-marker{display:none}",
      /* Icon-Rondell links vom Label, Muster aus Spec 3.8 (Hub-Liste): 32px
         Kreis, --dsn-tint-Flaeche, Akzentfarbe fuer das Icon. Eigener Wrapper
         .dsst-summary-main statt Icon+Label direkt in .dsst-summary, sonst
         zerlegt justify-content:space-between drei statt zwei Elemente. */
      "ds-steuer-rechner .dsst-summary-main{display:flex;align-items:center;gap:12px;min-width:0}",
      "ds-steuer-rechner .dsst-summary-icon{flex:0 0 32px;width:32px;height:32px;border-radius:999px;",
      "  background:var(--dsn-tint);display:flex;align-items:center;justify-content:center}",
      "ds-steuer-rechner .dsst-summary-icon svg{width:16px;height:16px;color:var(--dsn-accent);display:block}",
      "ds-steuer-rechner .dsst-summary::after{content:'';width:7px;height:7px;flex:none;margin-left:8px;",
      "  border:solid var(--dsn-ink-2);border-width:0 1.5px 1.5px 0;transform:rotate(45deg);",
      "  transition:transform .15s}",
      "ds-steuer-rechner .dsst-details[open] .dsst-summary::after{transform:rotate(-135deg)}",
      "ds-steuer-rechner .dsst-details > *:not(.dsst-summary){margin-top:0;padding-bottom:14px}",
      /* Geltungsbereich einer Pflicht ("nur gelistete", "gelistete und große Hunde").
         Steht rechts wie ein Wert, ist aber Text: die Foundation gibt .dsn-kv > b ein
         white-space:nowrap, das hier auf 390 px horizontal ueberliefe. Also eigene
         Klasse, die umbricht. Selektor bewusst spezifischer als .dsn-kv > span
         (Foundation), sonst entscheidet die Ladereihenfolge der Stylesheets. */
      "ds-steuer-rechner .dsn-kv > .dsst-gilt{color:var(--dsn-ink);font-weight:600;text-align:right;",
      "  max-width:60%;overflow-wrap:break-word;font-variant-numeric:normal}",
      "ds-steuer-rechner .dsst-print-only{display:none}",
      "@media (max-width:480px){ds-steuer-rechner .dsst-amount{font-size:29px}}",

      /* ---------- Druckstück (A4, DIN 5008) ----------
         Der Systemdialog macht das PDF: kein Server, keine Fremd-Library,
         nichts verlässt den Browser. Das Blatt geht mit zum Amt, deshalb ist
         das Branding hier kein Marketing, sondern die rechtliche Abgrenzung:
         ein sichtbar von uns stammendes Dokument kann niemand für ein
         Behördenschreiben halten. */
      "@media print{",
      "@page{size:A4;margin:20mm 18mm}",
      "body *{visibility:hidden}",
      "ds-steuer-rechner,ds-steuer-rechner *{visibility:visible}",
      "ds-steuer-rechner{position:absolute;left:0;top:0;width:100%;color:#000;font-size:10pt;line-height:1.45}",
      /* Bedienelemente raus: ein Ausdruck hat keine Buttons */
      "ds-steuer-rechner .dsst-form,ds-steuer-rechner .dsst-actions,ds-steuer-rechner .dsn-sub,",
      "ds-steuer-rechner .dsst-hits,ds-steuer-rechner .dsn-seg-track,ds-steuer-rechner .dsst-toggle,",
      "ds-steuer-rechner .dsn-label{display:none!important}",
      "ds-steuer-rechner .dsn-card,ds-steuer-rechner .dsn-result{border:none;box-shadow:none;padding:0;background:none;margin:0}",
      "ds-steuer-rechner .dsst-print-only{display:block}",
      /* Ausklapper werden vor dem Druck per JS geoeffnet (beforeprint-Listener),
         hier nur noch die Bildschirm-Anmutung (Pfeil, Cursor) fuers Papier tilgen. */
      "ds-steuer-rechner .dsst-summary{cursor:default;padding:2mm 0;font-weight:700}",
      "ds-steuer-rechner .dsst-summary::after{display:none}",
      "ds-steuer-rechner .dsst-summary-icon{display:none}",
      /* Briefkopf */
      "ds-steuer-rechner .dsst-ph{display:flex;align-items:flex-start;justify-content:space-between;",
      "  border-bottom:1.5pt solid #000;padding-bottom:4mm;margin-bottom:6mm}",
      "ds-steuer-rechner .dsst-ph img{max-height:12mm;width:auto}",
      "ds-steuer-rechner .dsst-ph-meta{text-align:right;font-size:8pt;line-height:1.5;color:#333}",
      "ds-steuer-rechner .dsst-ph-titel{font-size:16pt;font-weight:700;letter-spacing:-.01em;margin:0 0 1mm}",
      "ds-steuer-rechner .dsst-ph-sub{font-size:9pt;color:#333;margin:0}",
      /* Hero-Zahl */
      "ds-steuer-rechner .dsst-amount{font-size:26pt;font-weight:700;margin:0 0 1mm;color:#000}",
      "ds-steuer-rechner .dsst-amount-sub{font-size:10pt;color:#333;margin:0 0 5mm}",
      /* Key-Value */
      "ds-steuer-rechner .dsn-kv{display:flex;justify-content:space-between;padding:1.5mm 0;",
      "  border-bottom:.4pt solid #bbb;font-size:10pt}",
      "ds-steuer-rechner .dsn-num{font-weight:600;font-variant-numeric:tabular-nums}",
      /* Zitat als Beleg */
      "ds-steuer-rechner .dsst-quote{font-size:9pt;line-height:1.5;color:#222;margin:4mm 0 0;",
      "  padding:2mm 3mm;border-left:1.5pt solid #000;background:#f4f4f5;page-break-inside:avoid}",
      "ds-steuer-rechner .dsst-src{font-size:8.5pt;color:#333;margin:3mm 0 0}",
      "ds-steuer-rechner .dsn-note{font-size:8.5pt;color:#333;margin:2mm 0 0}",
      /* Pflichten-Block: der eigentliche Nutzen am Behördenschalter */
      "ds-steuer-rechner .dsst-pflichten{margin:6mm 0 0;page-break-inside:avoid}",
      "ds-steuer-rechner .dsst-pflichten h3{font-size:11pt;font-weight:600;margin:0 0 2mm;",
      "  padding-bottom:1mm;border-bottom:.4pt solid #bbb}",
      "ds-steuer-rechner .dsst-pflicht{display:flex;gap:3mm;padding:1.5mm 0;font-size:9.5pt;line-height:1.45}",
      "ds-steuer-rechner .dsst-pflicht-box{flex:0 0 3.5mm;height:3.5mm;border:.8pt solid #333;margin-top:.8mm}",
      /* Fuß: Urheber, Rechte, Shop, Haftungsgrenze */
      "ds-steuer-rechner .dsst-pf{margin:8mm 0 0;padding-top:3mm;border-top:.4pt solid #bbb;",
      "  font-size:7.5pt;line-height:1.6;color:#444;page-break-inside:avoid}",
      "ds-steuer-rechner .dsst-pf strong{color:#000}",
      "ds-steuer-rechner a{color:#000;text-decoration:none}",
      "ds-steuer-rechner .dsn-cta svg{display:none}",
      "}"
    ].join('');
    document.head.appendChild(style);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  /* Natives <details>/<summary>: Toggle-Verhalten und Tastatur-/Screenreader-
     Unterstuetzung kommen gratis mit, kein eigenes JS noetig (Recherche 19.07.2026,
     GOV.UK Design System "Details"-Komponente, Baymard/NN.G: Accordion schlaegt
     Tabs auf Mobile). body darf ein Node oder ein Array von Nodes sein. iconSvg ist
     optional: 32px Icon-Rondell links vom Label, Muster aus Spec 3.8 (Hub-Liste),
     hier auf die drei Ausklapper uebertragen (GF-Fund 19.07.2026: "sieht nicht neu
     aus" bei reinem Text-Chevron). */
  function details(summaryText, body, iconSvg) {
    var d = el('details', 'dsst-details');
    var s = el('summary', 'dsst-summary');
    var main = el('span', 'dsst-summary-main');
    if (iconSvg) {
      var icon = el('span', 'dsst-summary-icon');
      icon.innerHTML = iconSvg;
      icon.setAttribute('aria-hidden', 'true');
      main.appendChild(icon);
    }
    main.appendChild(el('span', '', summaryText));
    s.appendChild(main);
    d.appendChild(s);
    (Array.isArray(body) ? body : [body]).forEach(function (n) { if (n) d.appendChild(n); });
    return d;
  }

  /* Wandernder Chevron bei externen Text-CTAs, PDP-Signatur (Spec 3.1), identisch
     zu ds-tm-rechner.js/ds-futter-rechner.js. Fehlte hier komplett (GF-Befund
     19.07.2026, "Apple-HIG-Politur"): reiner Text ohne Pfeil wirkt unfertig neben
     den anderen Navigator-Flaechen. */
  var ARROW_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="12" x2="19" y2="12"></line><polyline points="13 6 19 12 13 18"></polyline></svg>';
  /* Drei Icon-Rondelle fuer die Ausklapper: Beleg (Dokument), Pflichten (Haken),
     Quelle (Amt/Institution). Einfache, geometrische Line-Icons (Feather/Lucide-
     Stil, kein Emoji, konsistente stroke-width mit ARROW_SVG). */
  var ICON_QUOTE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="8" y1="13" x2="16" y2="13"></line><line x1="8" y1="17" x2="13" y2="17"></line></svg>';
  var ICON_PFLICHT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"></path><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg>';
  var ICON_QUELLE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="21" x2="21" y2="21"></line><line x1="6" y1="18" x2="6" y2="11"></line><line x1="10" y1="18" x2="10" y2="11"></line><line x1="14" y1="18" x2="14" y2="11"></line><line x1="18" y1="18" x2="18" y2="11"></line><polygon points="12 3 21 8 3 8"></polygon></svg>';
  function ctaLink(text, href) {
    var a = el('a', 'dsn-cta', text);
    a.href = href;
    a.target = '_blank';
    a.rel = 'noopener';
    var arrow = el('span', '');
    arrow.innerHTML = ARROW_SVG;
    arrow.setAttribute('aria-hidden', 'true');
    a.appendChild(arrow);
    return a;
  }

  function eur(n) {
    return String(n).replace('.', ',') + ' Euro';
  }

  function deDatum(iso) {
    if (!iso || iso.length < 10) return iso || '';
    return iso.slice(8, 10) + '.' + iso.slice(5, 7) + '.' + iso.slice(0, 4);
  }

  function heute() {
    var d = new Date();
    return d.toISOString().slice(0, 10);
  }

  class DsSteuerRechner extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      ensureFoundation();
      injectStyles();
      this.daten = (window.DS_STEUER_DATEN && window.DS_STEUER_DATEN.kommunen) || [];
      this.gewaehlt = null;
      this.anzahl = 1;
      this.listen = false;
      this.render();

      /* Ausklapper sind ein Bildschirm-Kompromiss, das gedruckte Blatt braucht
         den vollen Inhalt (geht mit zum Amt). Vor dem Druck (Button ODER Cmd+P)
         alle <details> oeffnen, danach den Ausgangszustand wiederherstellen,
         damit die Ansicht am Bildschirm nicht ueberraschend alles aufklappt. */
      var self = this;
      var zuKlappen = [];
      window.addEventListener('beforeprint', function () {
        zuKlappen = Array.prototype.slice.call(self.querySelectorAll('details:not([open])'));
        zuKlappen.forEach(function (d) { d.open = true; });
      });
      window.addEventListener('afterprint', function () {
        zuKlappen.forEach(function (d) { d.open = false; });
        zuKlappen = [];
      });
    }

    render() {
      var self = this;
      var scope = el('div', 'dsn-scope');
      var card = el('div', 'dsn-card');

      /* Briefkopf: nur im Druck sichtbar. Wird in zeige() mit dem Ortsnamen
         befuellt, damit das Blatt einen echten Titel traegt. */
      this.printHead = el('div', 'dsst-print-only dsst-ph');
      card.appendChild(this.printHead);

      card.appendChild(el('p', 'dsn-title', 'Was nennt die Satzung deiner Stadt?'));
      card.appendChild(el('p', 'dsn-sub', 'Jede Gemeinde legt ihre Hundesteuer selbst fest. Wir zeigen dir den Satz aus der Satzung, mit Quelle und Lesedatum.'));

      var form = el('div', 'dsst-form');
      var lbl = el('label', 'dsn-label', 'DEIN ORT');
      lbl.setAttribute('for', 'dsstOrt');
      form.appendChild(lbl);

      var input = el('input', 'dsn-input');
      input.id = 'dsstOrt';
      /* type=search statt text (GF-Befund 19.07.2026, Apple-HIG-Politur): bringt
         das native iOS-Loesch-Icon und die "Suchen"-Tastaturbeschriftung gratis,
         ohne eigenes JS. -webkit-appearance:none in injectStyles() haelt das
         eigene .dsn-input-Design gegen Safaris natives Suchfeld-Styling. */
      input.type = 'search';
      input.setAttribute('enterkeyhint', 'search');
      input.setAttribute('autocomplete', 'off');
      input.placeholder = 'Ort eingeben';
      form.appendChild(input);

      /* Abdeckung VOR der Eingabe. Ein Suchfeld, das so aussieht, als kenne es
         alle 10.749 Gemeinden, ist eine konkludente Vollstaendigkeitsbehauptung,
         auch ohne ein einziges Wort. Design traegt hier die Compliance. */
      var cov = coverage(this.daten);
      var covText = 'Hinterlegt sind ' + cov.staedte + ' Städte, in denen rund '
        + Math.round(cov.einwohner / 1e6) + ' Millionen Menschen leben, jede einzeln aus ihrer Satzung erfasst. '
        + 'Das ist ein Ausschnitt, nicht das ganze Land: In Deutschland erhebt jede Gemeinde ihre eigene Hundesteuer, '
        + 'das sind über zehntausend Satzungen. Ist deine nicht dabei, findest du unten den Weg zu ihrer Satzung.';
      this.covNote = el('p', 'dsn-note', covText);
      form.appendChild(this.covNote);

      this.hits = el('div', 'dsst-hits');
      form.appendChild(this.hits);
      card.appendChild(form);

      this.result = el('div', '');
      this.result.setAttribute('aria-live', 'polite');
      card.appendChild(this.result);

      /* Index beim ersten Fokus laden, damit die Vorschlaege beim zweiten
         Buchstaben schon stehen und die Artikel-Leser, die nie tippen,
         die 156 KB nicht bezahlen. */
      input.addEventListener('focus', function () { self.ladeIndex(); });
      /* Jede Eingabe verwirft die alte Auswahl. Sonst bleibt das Ergebnis
         (144 Euro fuer Mannheim) stehen, wenn der Nutzer den Ort loescht oder
         eine neue Stadt zu tippen beginnt. Das Ergebnis erscheint erst wieder,
         wenn er aus der Liste waehlt. Programmatisches input.value = name (bei
         der Auswahl) feuert 'input' NICHT, also kein Konflikt. */
      input.addEventListener('input', function () {
        self.reset();
        self.suche(input.value);
      });
      this.input = input;

      scope.appendChild(card);
      this.appendChild(scope);
    }

    /* Der Ortsindex (2.943 Gemeinden, ~156 KB) wird erst beim ersten Fokus
       geladen, nicht beim Seitenaufruf: die Mehrheit der Artikel-Leser tippt
       nie. Ein GET auf eine statische Datei ohne Nutzereingabe im Pfad, damit
       bleibt die Zusage "deine Eingaben verlassen den Browser nicht" wahr. */
    ladeIndex() {
      if (this.orte || this.laedt) return;
      var self = this;
      var url = this.getAttribute('orte-url');
      if (!url || !window.DS_STEUER_SUCHE) return;
      this.laedt = true;
      fetch(url).then(function (r) { return r.json(); }).then(function (idx) {
        self.orte = window.DS_STEUER_SUCHE.expand(idx);
        self.laedt = false;
        if (self.input && self.input.value) self.suche(self.input.value);
      }).catch(function () {
        self.laedt = false;
        self.hits.appendChild(el('p', 'dsn-note',
          'Die Ortsliste konnte nicht geladen werden. Lade die Seite neu oder such deine Gemeinde direkt in ihrer Satzung.'));
      });
    }

    suche(q) {
      /* Der Abdeckungstext ist die Erstinformation vor der Eingabe. Sobald getippt
         wird, blockiert er nur noch die Sicht auf die Treffer direkt unter dem Feld
         (GF-Befund 19.07.2026: Ergebnis war ohne Scrollen unsichtbar). Weg, sobald
         Text im Feld steht, zurueck, sobald das Feld wieder leer ist. */
      if (this.covNote) this.covNote.style.display = q ? 'none' : '';
      while (this.hits.firstChild) this.hits.removeChild(this.hits.firstChild);
      if (!this.orte) { this.ladeIndex(); return; }
      var treffer = window.DS_STEUER_SUCHE.suche(this.orte, q);
      if (!treffer.length) return;
      var self = this;
      /* Bundesland getippt: erklaeren, dass die Steuer Gemeindesache ist, und die
         groessten Staedte des Landes zeigen. Beantwortet die Frage "gilt das fuers
         Bundesland oder die Stadt": es ist immer die Stadt. */
      if (treffer.blLand) {
        this.hits.appendChild(el('p', 'dsn-note',
          'Die Hundesteuer legt jede Stadt selbst fest, nicht das Land. Das sind die größten Städte in '
          + treffer.blLand + ' – wähle deine.'));
      }
      var list = el('div', 'dsn-list');
      treffer.forEach(function (o) {
        var satz = self.satzFuer(o.ags);
        var row = el('button', 'dsn-row');
        row.type = 'button';
        var links = el('span', 'dsst-ort');
        links.appendChild(el('span', 'dsst-ort-name', o.name));
        var meta = o.bl + (o.kreis && o.kreis !== o.name ? ' · ' + o.kreis : '');
        links.appendChild(el('span', 'dsst-ort-meta', meta));
        row.appendChild(links);
        /* Ehrlich in der Liste: erfasst oder nicht. Wer eine kleine Gemeinde
           sucht, soll das sehen, bevor er klickt, nicht danach. */
        row.appendChild(el('span', satz ? 'dsn-num' : 'dsn-note',
          satz ? (satz.saetze[0] + ' €') : 'noch nicht erfasst'));
        row.addEventListener('click', function () {
          self.gewaehlt = satz || null;
          self.ort = o;
          self.input.value = o.name;
          while (self.hits.firstChild) self.hits.removeChild(self.hits.firstChild);
          self.zeige();
        });
        list.appendChild(row);
      });
      this.hits.appendChild(list);
    }

    satzFuer(ags) {
      for (var i = 0; i < this.daten.length; i++) {
        if (this.daten[i].ags === ags) return this.daten[i];
      }
      return null;
    }

    /* Setzt Ergebnis und Auswahl auf den Startzustand. Wird bei jeder Eingabe
       gerufen: loescht der Nutzer den Ort oder tippt eine neue Stadt, verschwindet
       das alte Ergebnis, statt stehenzubleiben. Auch Anzahl, Rasse und die
       Aufklappung werden zurueckgesetzt, sonst traegt eine neue Stadt die alten
       Hunde und die alte Rassenwahl. */
    reset() {
      this.gewaehlt = null;
      this.ort = null;
      this.anzahl = 1;
      this.listen = false;
      this.kat1 = false;
      this.rasse = null;
      this.rassenOffen = false;
      this.unsicher = false;
      if (this.result) {
        while (this.result.firstChild) this.result.removeChild(this.result.firstChild);
      }
    }

    /* Zeigt die getroffenen Annahmen und macht sie aenderbar.
       Rasse-Frage NUR, wenn das Bundesland ueberhaupt eine Liste fuehrt.
       In NI, SH, TH, MV und BB entfaellt sie, und das ist eine wahre,
       nuetzliche Aussage, die kein Wettbewerber trifft. */
    annahmen(k) {
      var self = this;
      var wrap = el('div', 'dsst-annahmen');
      var bl = (window.DS_STEUER_LAENDER && window.DS_STEUER_LAENDER[k.bl]) || null;

      var seg = el('div', 'dsn-seg-track');
      [1, 2, 3].forEach(function (n) {
        var b = el('button', 'dsn-seg' + (self.anzahl === n ? ' is-active' : ''), n === 3 ? '3+' : String(n));
        b.type = 'button';
        b.setAttribute('aria-pressed', self.anzahl === n ? 'true' : 'false');
        b.addEventListener('click', function () { self.anzahl = n; self.zeige(); });
        seg.appendChild(b);
      });
      var segLbl = el('p', 'dsn-label', 'ANZAHL HUNDE');
      wrap.appendChild(segLbl);
      wrap.appendChild(seg);

      /* Land ohne Liste: die Frage entfaellt. Das ist eine wahre, nuetzliche
         Aussage, die kein Wettbewerber trifft, und null Reibung fuer die
         Mehrheit.

         ABER: "keine Liste" heisst nicht ueberall dasselbe. Mecklenburg-Vorpommern
         hat die Liste zum 23.07.2022 gestrichen UND per § 12 HundehVO M-V die alte
         Vermutung fuer vier Rassen fortgeschrieben. Der pauschale Satz waere fuer
         Altbestands-Halter eine falsche Entwarnung: sie liefen in Auflagenverstoesse
         (Leine, Maulkorb, Erlaubnis), weil wir Entwarnung geben. Deshalb darf jedes
         Land seinen eigenen Wortlaut mitbringen. Gleiches Muster wie listen_hinweis. */
      if (bl && bl.rasseliste === false) {
        wrap.appendChild(el('p', 'dsn-note', bl.hinweis
          || ('In ' + bl.name + ' gibt es keine Rasseliste'
            + (bl.liste_abgeschafft ? ' (abgeschafft ' + deDatum(bl.liste_abgeschafft) + ')' : '')
            + '. Die Rasse deines Hundes spielt für die Steuer hier keine Rolle.')));
        return wrap;
      }
      /* Gemeinde erhebt keinen Zuschlag: Frage waere sinnlos. */
      if (k.listen_satz === null && k.listen_geprueft) {
        wrap.appendChild(el('p', 'dsn-note',
          k.listen_hinweis || ('Die Satzung von ' + k.name + ' nennt keinen erhöhten Satz für gelistete Hunde.')));
        return wrap;
      }
      if (!bl || !bl.kat1) {
        wrap.appendChild(el('p', 'dsn-note',
          'Für ' + k.bl + ' haben wir die Rasseliste noch nicht geprüft. Wir zeigen hier lieber nichts als etwas Ungeprüftes.'));
        return wrap;
      }

      /* Annahme statt Frage: rund 97 % der Hunde stehen auf keiner Liste. Die
         Mehrheit soll nicht durch 19 Rassen scrollen, sondern die Annahme
         schwarz auf weiss lesen und weitergehen. Wer abweicht, klappt auf.
         Ein Formular mit Default waere dasselbe, nur versteckt. */
      var alle = (bl.kat1 || []).concat(bl.kat2 || []);

      if (!this.rassenOffen && !this.rasse) {
        var p = el('p', 'dsst-annahme');
        p.appendChild(document.createTextNode('Gerechnet ohne Aufschlag für gelistete Rassen. '));
        var auf = el('button', 'dsn-cta dsst-toggle', 'Mein Hund steht auf der Liste');
        auf.type = 'button';
        auf.addEventListener('click', function () { self.rassenOffen = true; self.zeige(); });
        p.appendChild(auf);
        wrap.appendChild(p);
        wrap.appendChild(el('p', 'dsn-note', bl.name + ' führt '
          + (alle.length === 1 ? 'eine Rasse' : alle.length + ' Rassen')
          + ' auf der Liste. Sie steht in ' + (bl.rechtsgrundlage || 'der Landesverordnung') + '.'));
        if (bl.grosse_hunde) {
          wrap.appendChild(el('p', 'dsn-note', 'Unabhängig von der Rasse: ' + bl.grosse_hunde.hinweis));
        }
        return wrap;
      }

      /* Aufgeklappt: nur die Rassen DIESES Landes (3 bis 19), nicht 400.
         Die Frage ist nicht "welche Rasse", sondern "steht dein Hund auf der
         Liste deines Landes", und die haengt am Ort, den wir schon haben.

         Kopfzeile mit Schliessen-Button: der GF fand das Zuklappen unauffindbar,
         es ging nur ueber "Keine davon". Jetzt gibt es rechts oben ein klares X. */
      var kopf = el('div', 'dsst-rassen-kopf');
      kopf.appendChild(el('span', 'dsn-label', 'RASSEN AUF DER LISTE IN ' + bl.name.toUpperCase()));
      var zu = el('button', 'dsst-schliessen', 'Schließen');
      zu.type = 'button';
      zu.setAttribute('aria-label', 'Rassenauswahl schließen');
      zu.addEventListener('click', function () {
        self.rasse = null; self.listen = false; self.kat1 = false; self.unsicher = false;
        self.rassenOffen = false; self.zeige();
      });
      kopf.appendChild(zu);
      wrap.appendChild(kopf);
      var liste = el('div', 'dsn-list dsst-rassen');

      var keine = el('button', 'dsn-row');
      keine.type = 'button';
      var keineAktiv = !this.rasse && !this.unsicher;
      keine.setAttribute('aria-pressed', keineAktiv ? 'true' : 'false');
      keine.appendChild(el('span', '', 'Keine davon'));
      keine.appendChild(el('span', 'dsn-tick' + (keineAktiv ? ' dsn-tick--on' : ''), ''));
      keine.addEventListener('click', function () {
        self.rasse = null; self.listen = false; self.kat1 = false; self.unsicher = false;
        self.rassenOffen = false; self.zeige();
      });
      liste.appendChild(keine);

      /* "Ich weiss nicht": der GF fragte, was ist, wenn man die Einstufung nicht
         kennt. Ehrliche Antwort: die Behoerde entscheidet, bei Mischlingen per
         Wesenstest. Solange nichts festgestellt ist, gilt der normale Satz, wir
         rechnen also NICHT den Aufschlag, zeigen ihn aber als Moeglichkeit. */
      var unsicherRow = el('button', 'dsn-row');
      unsicherRow.type = 'button';
      unsicherRow.setAttribute('aria-pressed', this.unsicher ? 'true' : 'false');
      unsicherRow.appendChild(el('span', '', 'Ich bin nicht sicher'));
      unsicherRow.appendChild(el('span', 'dsn-tick' + (this.unsicher ? ' dsn-tick--on' : ''), ''));
      unsicherRow.addEventListener('click', function () {
        self.rasse = null; self.listen = false; self.kat1 = false; self.unsicher = true; self.zeige();
      });
      liste.appendChild(unsicherRow);

      alle.forEach(function (r) {
        var istKat1 = (bl.kat1 || []).indexOf(r) > -1;
        var row = el('button', 'dsn-row');
        row.type = 'button';
        row.setAttribute('aria-pressed', self.rasse === r ? 'true' : 'false');
        var links = el('span', 'dsst-ort');
        links.appendChild(el('span', 'dsst-ort-name', r));
        links.appendChild(el('span', 'dsst-ort-meta', istKat1 ? 'Kategorie 1' : 'Kategorie 2'));
        row.appendChild(links);
        row.appendChild(el('span', 'dsn-tick' + (self.rasse === r ? ' dsn-tick--on' : ''), ''));
        row.addEventListener('click', function () {
          self.rasse = r;
          self.listen = true;
          self.kat1 = istKat1;
          self.zeige();
        });
        liste.appendChild(row);
      });
      wrap.appendChild(liste);

      /* Nie "Dein Hund ist ein Listenhund". Die Einstufung im Einzelfall trifft
         die Behoerde, bei Mischlingen oft per Wesenstest. */
      if (this.rasse) {
        var k1 = this.kat1;
        var info = el('div', 'dsn-subcard');
        info.appendChild(el('p', 'dsn-subcard-title',
          this.rasse + ' in ' + bl.name + ': Kategorie ' + (k1 ? '1' : '2')));
        info.appendChild(el('p', 'dsn-text', k1 ? (bl.kat1_hinweis || '') : (bl.kat2_hinweis || '')));

        /* Der Unterschied, den ein einzelnes Boolean nicht abbilden kann:
           In NRW befreit die Pruefung nur von Leine und Maulkorb, der Hund
           bleibt rechtlich gefaehrlich. In HH und BW entfaellt der Status. */
        if (k1 && bl.entlistung_moeglich) {
          info.appendChild(el('p', 'dsn-text', 'Der Status lässt sich widerlegen. ' + (bl.entlistung_hinweis || '')));
        } else if (k1 && bl.auflagenbefreiung_moeglich && !bl.entlistung_moeglich) {
          info.appendChild(el('p', 'dsn-text', bl.auflagenbefreiung_hinweis
            || 'Auflagen wie Leine und Maulkorb lassen sich per Prüfung abbauen, der Status als gefährlicher Hund bleibt aber bestehen.'));
        } else if (!k1 && bl.entlistung_moeglich) {
          info.appendChild(el('p', 'dsn-text', bl.entlistung_hinweis || ''));
        }

        /* Haltungsverbot: Gemeinde schlaegt Land. Muenchen verbietet Kat-1,
           obwohl Bayern es landesweit erlaubt. Nur EINE Warnung zeigen, sonst
           steht dieselbe Aussage zweimal untereinander. */
        if (k.kat1_verboten && k1) {
          info.appendChild(el('p', 'dsn-alert dsn-alert--warn',
            k.kat1_hinweis || ('In ' + k.name + ' ist die Haltung dieser Hunde nicht erlaubt.')));
        } else if (bl.haltungsverbot && bl.haltungsverbot.indexOf(this.rasse) > -1) {
          info.appendChild(el('p', 'dsn-alert dsn-alert--warn', bl.haltungsverbot_hinweis
            || ('Die Haltung dieser Rasse ist in ' + bl.name + ' verboten. Dafür gibt es keinen Steuersatz.')));
        }

        info.appendChild(el('p', 'dsn-note',
          'Ob dein Hund unter diese Rasse fällt, entscheidet die Behörde, bei Mischlingen oft über einen Wesenstest. '
          + 'Rechtsgrundlage: ' + (bl.rechtsgrundlage || '') + (bl.paragraph ? ', ' + bl.paragraph : '') + '.'));
        if (bl.quelle_url) {
          info.appendChild(ctaLink('Gesetzestext ansehen', bl.quelle_url));
        }
        wrap.appendChild(info);
      } else if (this.unsicher) {
        /* Ehrliche Antwort auf "ich weiss nicht": nicht raten, sondern erklaeren,
           wer entscheidet, und den Aufschlag als Moeglichkeit zeigen, ohne ihn
           als Tatsache zu berechnen. Solange keine Einstufung vorliegt, gilt der
           normale Satz. */
        var uinfo = el('div', 'dsn-subcard');
        uinfo.appendChild(el('p', 'dsn-subcard-title', 'Noch nicht eingestuft?'));
        uinfo.appendChild(el('p', 'dsn-text',
          'Ob ein Hund als gelistet gilt, entscheidet die Behörde, bei Mischlingen oft über einen Wesenstest. '
          + 'Solange nichts festgestellt ist, zahlst du den normalen Satz. Oben steht deshalb der normale Betrag.'));
        var lSatz = (k.listen_staffel && k.listen_staffel[0]) || k.listen_satz;
        if (lSatz) {
          uinfo.appendChild(el('p', 'dsn-note',
            'Würde deine Gemeinde den Hund als gelistet einstufen, läge der Satz bei ' + lSatz + ' Euro je Jahr. '
            + 'Prüfe im Zweifel bei deiner Behörde, ob eine Einstufung vorliegt.'));
        }
        wrap.appendChild(uinfo);
      }

      /* Rasseunabhaengige Pflichten: NRW § 11 trifft jeden Hund ab 40 cm oder
         20 kg. Das betrifft weit mehr Halter als jede Rasseliste. */
      if (bl.grosse_hunde) {
        wrap.appendChild(el('p', 'dsn-note', 'Unabhängig von der Rasse: ' + bl.grosse_hunde.hinweis));
      }
      return wrap;
    }

    /* Der Normalfall, nicht der Fehlerfall: Von 2.943 auffindbaren Gemeinden
       haben wir einen Bruchteil erhoben. Trotzdem darf hier keine Sackgasse
       stehen. Was wir liefern koennen, liefern wir vollstaendig (Landesrecht
       gilt fuer JEDEN Ort), und fuer den Rest den Weg zur Satzung.
       NIE eine Schaetzung: eine erfundene Zahl waere genau der Fehler, der
       heute im Artikel steht (Koeln 672). */
    zeigeFallback(o) {
      var box = el('div', 'dsn-result dsn-step-in');
      var bl = (window.DS_STEUER_LAENDER && window.DS_STEUER_LAENDER[o.bl]) || null;
      var land = bl ? bl.name : o.bl;

      box.appendChild(el('p', 'dsn-title', o.name + ' haben wir noch nicht erfasst'));
      box.appendChild(el('p', 'dsn-text',
        'Den Steuersatz nennt nur die Satzung von ' + o.name + ' selbst, und die haben wir noch nicht gelesen. '
        + 'Wir raten hier nicht: eine geschätzte Zahl wäre schlimmer als keine.'));

      /* Landesebene gilt fuer JEDEN Ort im Land, auch fuer nicht erfasste.
         Das ist der ehrliche Wert, den wir trotzdem haben. */
      if (bl) {
        var lbox = el('div', 'dsn-subcard');
        lbox.appendChild(el('p', 'dsn-subcard-title', 'Das gilt in ' + land + ', unabhängig von der Gemeinde'));
        if (bl.rasseliste === false) {
          lbox.appendChild(el('p', 'dsn-text', bl.hinweis
            || (land + ' führt keine Rasseliste' + (bl.liste_abgeschafft ? ' (abgeschafft ' + deDatum(bl.liste_abgeschafft) + ')' : '')
              + '. Die Rasse deines Hundes spielt hier keine Rolle.')));
        } else if (bl.kat1 && bl.kat1.length) {
          lbox.appendChild(el('p', 'dsn-text', 'Rasseliste: ' + bl.kat1.join(', ')
            + (bl.kat2 && bl.kat2.length ? ', ' + bl.kat2.join(', ') : '') + '.'));
          lbox.appendChild(el('p', 'dsn-note', 'Ob dein Hund darunter fällt, entscheidet die Behörde, bei Mischlingen oft über einen Wesenstest.'));
        }
        /* Die Pflicht-Felder tragen ihren GELTUNGSBEREICH als Text ("alle Hunde",
           "nur gelistete", "gelistete und große Hunde"), nicht true/false. Wer sie
           als Boolean liest und pauschal "Pflicht" schreibt, sagt dem Chihuahua-Halter
           in Koeln, er brauche Sachkunde, Chip und Haftpflicht: in NRW gilt das nur
           fuer gelistete und fuer Hunde ab 40 cm / 20 kg (§ 11 LHundG). Der Bereich
           IST die Aussage, er darf nie wegfallen. */
        [['sachkunde_pflicht', 'Sachkundenachweis'], ['chip_pflicht', 'Kennzeichnung per Chip'], ['haftpflicht_pflicht', 'Hundehaftpflicht']].forEach(function (p) {
          var v = bl[p[0]];
          if (!v) return;
          var r = el('div', 'dsn-kv');
          r.appendChild(el('span', '', p[1]));
          r.appendChild(el('span', 'dsst-gilt', v === true ? 'Pflicht' : v));
          lbox.appendChild(r);
        });
        if (bl.haftpflicht_summe) {
          lbox.appendChild(el('p', 'dsn-note', 'Deckungssumme: ' + bl.haftpflicht_summe + '.'));
        }
        if (bl.quelle_url) {
          var q = el('p', 'dsn-note');
          q.appendChild(document.createTextNode((bl.rechtsgrundlage || land) + ', geprüft am ' + deDatum(bl.geprueft_am) + '. '));
          q.appendChild(ctaLink('Quelle', bl.quelle_url));
          lbox.appendChild(q);
        }
        box.appendChild(lbox);
      }

      /* Kreis-Einordnung. Der Kreis erhebt KEINE Hundesteuer (das macht die
         Gemeinde), er taugt nur als Orientierung. Deshalb explizit dazusagen,
         dass das kein Wert fuer diesen Ort ist. */
      var erfasst = this.daten.map(function (d) { return d.ags; });
      var kk = this.orte && window.DS_STEUER_SUCHE.kreisKontext(this.orte, o, erfasst);
      if (kk && kk.erfasst.length) {
        var werte = kk.erfasst.map(function (g) {
          var s = null;
          for (var i = 0; i < this.daten.length; i++) if (this.daten[i].ags === g.ags) s = this.daten[i];
          return s ? s.saetze[0] : null;
        }, this).filter(function (x) { return x !== null; });
        if (werte.length) {
          var min = Math.min.apply(null, werte), max = Math.max.apply(null, werte);
          box.appendChild(el('p', 'dsn-note',
            'Zur Einordnung: Im Kreis ' + kk.kreis + ' haben wir ' + werte.length
            + (werte.length === 1 ? ' Gemeinde' : ' Gemeinden') + ' erfasst, dort liegt der Satz für den ersten Hund '
            + (min === max ? 'bei ' + min : 'zwischen ' + min + ' und ' + max) + ' Euro. '
            + 'Das ist kein Wert für ' + o.name + ': jede Gemeinde entscheidet selbst.'));
        }
      }

      /* Der Weg zur Satzung. Wir haben die URL nicht, also geben wir den
         exakten Suchweg und die Fundstelle. 100 % wahr, konkret nuetzlich. */
      var weg = el('div', 'dsn-subcard');
      weg.appendChild(el('p', 'dsn-subcard-title', 'So findest du den Satz in zwei Minuten'));
      var such = o.name + ' Hundesteuersatzung';
      var p1 = el('p', 'dsn-text');
      p1.appendChild(document.createTextNode('1. Such nach '));
      var code = el('strong', '', '„' + such + '“');
      p1.appendChild(code);
      weg.appendChild(p1);
      weg.appendChild(el('p', 'dsn-text', '2. In der Satzung steht der Betrag unter „Steuersatz“, meist § 2 oder § 3.'));
      weg.appendChild(ctaLink('Suche öffnen', 'https://www.google.com/search?q=' + encodeURIComponent(such)));
      box.appendChild(weg);

      box.appendChild(el('p', 'dsn-note',
        'Wir erfassen laufend weitere Gemeinden. Fehlt deine und du hast die Satzung gefunden? Schreib uns an kontakt@dogssupreme.de, dann nehmen wir sie auf.'));

      this.result.appendChild(box);
    }

    zeige() {
      var k = this.gewaehlt;
      while (this.result.firstChild) this.result.removeChild(this.result.firstChild);
      if (!k) {
        if (this.ort) this.zeigeFallback(this.ort);
        return;
      }

      /* Verfalls-Gate zur Laufzeit: lieber keine Zahl als eine veraltete. */
      var lvl = staleLevel(k.geprueft_am, heute());
      if (lvl === 'unterdruecken') {
        var warn = el('div', 'dsn-alert dsn-alert--warn');
        warn.appendChild(el('p', '', 'Unsere Prüfung für ' + k.name + ' ist älter als 24 Monate. Wir zeigen den Wert deshalb nicht mehr an. Die aktuelle Satzung findest du hier:'));
        warn.appendChild(ctaLink('Satzung von ' + k.name, k.satzung_url));
        this.result.appendChild(warn);
        return;
      }

      /* Zweite Iteration des Mobile-Redesigns (GF-Fund 19.07.2026: "es hat sich
         nichts geaendert"). Eine einzelne graue Box fuer Betrag UND Beleg-Kram
         sah wie ein Textblock aus, keine Karte. Jetzt zwei sichtbar getrennte
         Flaechen, wie ein Wallet-Beleg ueber einer gruppierten Liste: die Zahl
         bekommt eine eigene weisse, angehobene Karte (.dsn-card, Schatten,
         Rand), der Beleg-Kram darunter bleibt die weichere graue Flaeche. */
      var hero = el('div', 'dsn-card dsst-hero dsn-step-in');
      var r = computeSteuer(k, { anzahl: this.anzahl, listen: this.listen, kat1: this.kat1 });

      if (r.verboten) {
        hero.appendChild(el('p', 'dsn-text', r.hinweise[0]));
      } else if (r.summe !== null) {
        hero.appendChild(el('p', 'dsst-amount', eur(r.summe) + ' pro Jahr'));
        hero.appendChild(el('p', 'dsst-amount-sub', 'für ' + (this.anzahl > 1 ? (this.anzahl + ' Hunde') : 'einen Hund') + ' in ' + k.name));
      } else if (r.teilsumme !== null) {
        hero.appendChild(el('p', 'dsst-amount', 'mindestens ' + eur(r.teilsumme)));
      }

      r.zeilen.forEach(function (z) {
        var row = el('div', 'dsn-kv');
        row.appendChild(el('span', '', z.label));
        row.appendChild(el('span', 'dsn-num', eur(z.wert)));
        hero.appendChild(row);
      });

      r.hinweise.forEach(function (h) { hero.appendChild(el('p', 'dsn-note', h)); });

      this.result.appendChild(hero);

      var box = el('div', 'dsn-result dsst-detailbox dsn-step-in');

      /* Annahme-getriebene Enthuellung: ~90 % halten einen Hund, ~97 % keinen
         gelisteten. Fuer die Mehrheit ist die Antwort nach EINER Eingabe fertig.
         Die Annahmen stehen ausgeschrieben unter der Zahl und sind antippbar.
         Ein Formular mit Defaults waere dasselbe, nur versteckt. */
      box.appendChild(this.annahmen(k));

      /* Mobile-Redesign 19.07.2026 (GF-Befund "riesenlang, muss unendlich scrollen",
         Recherche siehe evidence/2026-07-19/hundesteuer-mobile-fix/REPORT.md):
         Zitat, Pflichten und Quelle sind Beleg-Charakter, nicht fuer jeden Blick
         noetig, und wandern hinter native <details>-Ausklapper (GOV.UK-Muster,
         auf Mobile nachweislich schneller bedienbar als Tabs). Der Disclaimer-Satz
         bleibt IMMER sichtbar, das betrifft laut Recherche alle Nutzer, nicht nur
         die, die extra aufklappen. Jeder Ausklapper hat jetzt ein Icon-Rondell
         (Spec 3.8), das macht die drei Zeilen auf einen Blick unterscheidbar. */
      var z1 = k.zitat && (k.zitat.h1 || k.zitat.listen);
      if (z1) {
        var quoteP = el('p', 'dsst-quote', '„' + z1 + '“ (' + (k.paragraph || '') + ')');
        box.appendChild(details('Satzungszitat anzeigen', quoteP, ICON_QUOTE));
      }

      /* Pflichten-Block: der eigentliche Nutzen liegt am Behoerdenschalter,
         nicht am Rechnen. Im Druck als abhakbare Liste, am Bildschirm als
         Info. Formuliert als Satzungs-Fakt, NIE als To-do ("melde deinen Hund
         um" ist laut Rechtspruefung eine verbotene Handlungsempfehlung). */
      var pf = this.pflichten(k);
      if (pf.count) box.appendChild(details('Deine Pflichten (' + pf.count + ')', pf.wrap, ICON_PFLICHT));

      var src = el('p', 'dsst-src');
      src.appendChild(document.createTextNode('Stand der Satzung: ' + deDatum(k.stand) + '. Von uns geprüft am ' + deDatum(k.geprueft_am) + '. '));
      src.appendChild(ctaLink('Satzung ansehen', k.satzung_url));
      box.appendChild(details('Quelle und Stand', src, ICON_QUELLE));

      if (lvl === 'warnen') {
        box.appendChild(el('p', 'dsn-badge dsn-badge--warn', 'Unsere Prüfung ist über ein Jahr alt. Bitte in der Satzung gegenprüfen.'));
      }

      box.appendChild(el('p', 'dsn-note', 'Richtwert aus der Satzung von ' + k.name + ', gelesen am ' + deDatum(k.geprueft_am) + '. Verbindlich ist allein der Bescheid deiner Gemeinde.'));

      /* Der PDF-Weg ist ein Add-on, kein Hauptpfad: die wenigsten drucken.
         Deshalb Text-Link statt Kapsel-Button, damit die eine Akzent-Aktion
         pro View frei bleibt (Spec: max. 1 gefuellter Button). */
      var act = el('div', 'dsst-actions');
      if (k.anmeldung_url) {
        act.appendChild(ctaLink('Zur Anmeldeseite von ' + k.name, k.anmeldung_url));
      }
      var pdf = el('button', 'dsst-pdf', 'Als PDF sichern');
      pdf.type = 'button';
      pdf.setAttribute('aria-label', 'Diese Übersicht als PDF sichern oder drucken');
      pdf.addEventListener('click', function () { window.print(); });
      act.appendChild(pdf);
      box.appendChild(act);

      /* Druckfuss: Urheber, Rechte, Shop, Haftungsgrenze. Ein Ausdruck ist ein
         eingefrorener Snapshot, deshalb steht das Lesedatum drauf. */
      box.appendChild(this.druckFuss(k));

      this.result.appendChild(box);
      this.fuellePrintHead(k);
    }

    fuellePrintHead(k) {
      var ph = this.printHead;
      while (ph.firstChild) ph.removeChild(ph.firstChild);

      var links = el('div', '');
      var logo = this.getAttribute('logo-url');
      if (logo) {
        var img = document.createElement('img');
        img.src = logo;
        img.alt = 'Dogs Supreme';
        links.appendChild(img);
      }
      links.appendChild(el('p', 'dsst-ph-titel', 'Hundesteuer ' + k.name));
      links.appendChild(el('p', 'dsst-ph-sub', 'Was die Satzung nennt, mit Quelle und Lesedatum'));
      ph.appendChild(links);

      var rechts = el('div', 'dsst-ph-meta');
      rechts.appendChild(el('div', '', 'Erstellt am ' + deDatum(heute())));
      rechts.appendChild(el('div', '', k.name + ', ' + k.bl));
      rechts.appendChild(el('div', '', 'dogssupreme.de'));
      ph.appendChild(rechts);
    }

    /* Liefert {count, wrap} statt eines fertigen Blocks mit eigenem Titel: der
       Titel wandert als Anzahl ins <summary> des Ausklappers in zeige(), siehe
       Mobile-Redesign 19.07.2026 (GF-Befund "riesenlang, muss unendlich scrollen"). */
    pflichten(k) {
      var wrap = el('div', 'dsst-pflichten');
      var bl = (window.DS_STEUER_LAENDER && window.DS_STEUER_LAENDER[k.bl]) || null;
      var eintraege = [];

      if (k.frist_tage) {
        var wochen = Math.round(k.frist_tage / 7);
        eintraege.push('Anmeldung: Die Satzung von ' + k.name + ' nennt eine Frist von '
          + (wochen === 4 ? 'vier Wochen' : (wochen + (wochen === 1 ? ' Woche' : ' Wochen')))
          + ' nach Aufnahme des Hundes.');
      } else if (k.frist_hinweis) {
        /* Manche Satzungen nennen keine Tagesfrist, sondern "unverzueglich"
           (Regensburg § 11). Dann keinen Tageswert erfinden, den Wortlaut zeigen. */
        eintraege.push('Anmeldung: ' + k.frist_hinweis);
      }
      if (k.anmeldung_url) {
        eintraege.push('Zuständig: das Steueramt ' + k.name + ' (' + k.anmeldung_url.replace(/^https?:\/\//, '').split('/')[0] + ').');
      }
      if (bl) {
        if (bl.rasseliste === false) {
          eintraege.push(bl.hinweis
            || ('Rasseliste: ' + bl.name + ' führt keine. Die Rasse spielt für die Steuer hier keine Rolle.'));
        } else if (bl.kat1 && bl.kat1.length) {
          eintraege.push('Rasseliste ' + bl.name + ': ' + bl.kat1.slice(0, 5).join(', ')
            + (bl.kat2 && bl.kat2.length ? ' und weitere' : '') + '. Die Einstufung im Einzelfall trifft die Behörde.');
        }
        /* Der Wert IST der Geltungsbereich ("nur gelistete"), kein Boolean. Siehe
           die gleiche Stelle in der Landesbox. Das Blatt geht mit zum Amt, ein
           pauschales "Chip-Pflicht in NRW" waere dort besonders teuer. */
        [['sachkunde_pflicht', 'Sachkundenachweis'], ['chip_pflicht', 'Kennzeichnung per Chip'],
         ['haftpflicht_pflicht', 'Hundehaftpflicht']].forEach(function (p) {
          var v = bl[p[0]];
          if (!v) return;
          eintraege.push(p[1] + ': in ' + bl.name + ' ' + (v === true ? 'vorgeschrieben' : 'für ' + v + ' vorgeschrieben') + '.');
        });
        if (bl.haftpflicht_summe) {
          eintraege.push('Deckungssumme der Haftpflicht: ' + bl.haftpflicht_summe + '.');
        }
      }
      k.ermaessigung && k.ermaessigung.forEach(function (e) {
        if (e.bedingung) eintraege.push('Ermäßigung möglich: ' + e.bedingung + ' Ob das auf dich zutrifft, prüft deine Gemeinde.');
      });

      eintraege.forEach(function (t) {
        var z = el('div', 'dsst-pflicht');
        z.appendChild(el('span', 'dsst-pflicht-box dsst-print-only'));
        z.appendChild(el('span', '', t));
        wrap.appendChild(z);
      });
      return { count: eintraege.length, wrap: wrap };
    }

    druckFuss(k) {
      var f = el('div', 'dsst-print-only dsst-pf');
      var p1 = el('p', '');
      p1.appendChild(el('strong', '', 'Woher die Zahlen stammen: '));
      p1.appendChild(document.createTextNode(
        'Alle Beträge sind der Hundesteuersatzung von ' + k.name + ' entnommen ('
        + (k.paragraph || '') + '), gelesen am ' + deDatum(k.geprueft_am)
        + '. Der Wortlaut steht oben, die Quelle ist verlinkt.'));
      f.appendChild(p1);

      var p2 = el('p', '');
      p2.appendChild(el('strong', '', 'Was dieses Blatt nicht ist: '));
      p2.appendChild(document.createTextNode(
        'kein amtliches Dokument, keine Steuer- und keine Rechtsberatung. Verbindlich ist allein der Bescheid deiner Gemeinde. '
        + 'Gemeinden ändern ihre Satzungen meist zum Jahreswechsel: prüfe vor dem Behördengang die verlinkte Satzung.'));
      f.appendChild(p2);

      var p3 = el('p', '');
      p3.appendChild(document.createTextNode('Erstellt am ' + deDatum(heute()) + ' mit dem Hundesteuer-Rechner von '));
      p3.appendChild(el('strong', '', 'dogssupreme.de'));
      p3.appendChild(document.createTextNode('. Fehler gefunden? kontakt@dogssupreme.de. © ' + heute().slice(0, 4)
        + ' Dogs Supreme, Loyalty Clothing International GmbH. Weitergabe erlaubt, Änderung nicht.'));
      f.appendChild(p3);
      return f;
    }
  }

  customElements.define('ds-steuer-rechner', DsSteuerRechner);
})();
